/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {writeUserSettings} from '../api'

export const useMutationWriteUserSettings = createReactQueryMutationHook('writeUserSettings', writeUserSettings)
